export default function Installation() {
  const steps = [
    {
      number: '01',
      title: 'Étude Personnalisée',
      description: 'Visite technique gratuite, analyse de vos besoins, dimensionnement précis et calcul des économies potentielles. Devis détaillé avec subventions applicables.'
    },
    {
      number: '02',
      title: 'Choix du Modèle',
      description: 'Sélection de la pompe à chaleur ELCO adaptée à votre bâtiment et budget. Conseil expert sur le type (air-eau, géothermique, hybride) et la puissance optimale.'
    },
    {
      number: '03',
      title: 'Installation Professionnelle',
      description: 'Pose par nos techniciens certifiés ELCO, raccordements hydrauliques et électriques conformes OIBT/NIBT, isolation thermique et acoustique optimale.'
    },
    {
      number: '04',
      title: 'Mise en Service',
      description: 'Réglages précis, tests de performance, optimisation des paramètres et formation complète à l\'utilisation. Remise de la documentation technique et certificats.'
    }
  ];

  return (
    <section id="installation" className="py-24 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Notre Processus</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Installation Clé en Main
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            De l'étude à la mise en service, nous gérons votre projet de A à Z.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8 h-full border border-teal-100">
                <div className="text-5xl font-bold text-teal-600 mb-4 opacity-20">{step.number}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-teal-600"></i>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="bg-gradient-to-br from-gray-900 via-teal-900 to-gray-900 rounded-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative h-full min-h-[400px]">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20installation%20of%20ELCO%20heat%20pump%20by%20certified%20technician%20in%20modern%20Swiss%20home%2C%20detailed%20view%20of%20expert%20installer%20connecting%20premium%20white%20heat%20pump%20unit%20with%20precision%20tools%20and%20professional%20equipment%2C%20clean%20residential%20installation%20site%20with%20organized%20workspace%20and%20quality%20craftsmanship&width=800&height=600&seq=elco-installation&orientation=landscape" 
                alt="Installation pompe à chaleur ELCO"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-12">
              <h3 className="text-3xl font-bold text-white mb-6">Prêt à Passer au Chauffage Écologique ?</h3>
              <p className="text-gray-200 mb-6 leading-relaxed">
                Contactez-nous pour une étude gratuite et personnalisée. Nos experts vous conseilleront sur la meilleure solution ELCO pour votre projet et vous accompagneront dans l'obtention des subventions.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center text-white">
                  <i className="ri-check-line text-teal-400 text-xl mr-3"></i>
                  Visite technique gratuite à Genève
                </li>
                <li className="flex items-center text-white">
                  <i className="ri-check-line text-teal-400 text-xl mr-3"></i>
                  Devis détaillé sous 48h
                </li>
                <li className="flex items-center text-white">
                  <i className="ri-check-line text-teal-400 text-xl mr-3"></i>
                  Aide aux démarches de subventions
                </li>
                <li className="flex items-center text-white">
                  <i className="ri-check-line text-teal-400 text-xl mr-3"></i>
                  Installation rapide et soignée
                </li>
              </ul>
              <a href="#contact" className="inline-block rounded-full bg-teal-600 px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-teal-700 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer">
                Demander une étude gratuite
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
